import { Typography, Box, Button, Grid, Select, MenuItem } from "@mui/material";
import { BoxStyled } from "components/styled/BoxStyled";
import { TextFieldStyled } from "components/styled/TextField";
import React from "react";
import Loader from "components/shared/Loader";
import ButtonAction from "components/shared/ButtonAction";
import { useBusCreate } from "../hooks/useBusCreate";
import ButtonLoader from "components/shared/ButtonLoader";
import { useCompany } from "hooks/company/useCompany";
const BusCreate = () => {
  const {
    handleCancel,
    hanldeCreate,
    register,
    handleSubmit,
    handleReset,
    loading,
    t,
    errors,
    details,
  } = useBusCreate();

  const { data: companyData } = useCompany();
  const role = localStorage.getItem("role");

  return (
    <Box>
      {loading && <Loader />}
      <Typography sx={{ color: "text.main", mb: "16px" }} variant="h5">
        {t("Create Bus")}
      </Typography>
      <BoxStyled sx={{ px: "24px" }}>
        <Box component="form">
          <Grid container spacing={2}>
            {/* //* details */}
            {details.map((item, index) => (
              <Grid key={index} xs={6} sx={{ p: "10px" }}>
                <Box sx={{ margin: "0 0 8px 5px" }}>
                  <Typography variant="inputTitle">{item.head}</Typography>
                </Box>
                <TextFieldStyled
                  sx={{ width: "100%" }}
                  type={item.type}
                  placeholder={item.placeholder}
                  name={item.name}
                  {...register(item.register)}
                  error={errors[item.error]?.message}
                  helperText={errors[item.helperText]?.message || ""}
                />
              </Grid>
            ))}
            {role === "admin" && (
              <Grid item md={6} sx={{ p: "10px" }}>
                <Box sx={{ margin: "0 0 8px 5px" }}>
                  <Typography variant="inputTitle">{t("company")}</Typography>
                </Box>
                <Select
                  label={t("company")}
                  sx={{ mb: "10px", width: "100%" }}
                  name="company"
                  id="company"
                  {...register("company_id")}
                  error={errors?.company_id?.message}
                  helperText={errors?.company_id?.message || ""}
                >
                  {companyData?.companies?.map((item) => (
                    <MenuItem key={item} value={item?.id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
                <Typography sx={{ color: "error.main" }}>
                  {errors?.company_id?.message}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>

        <Box
          sx={{
            mt: "20px",
            display: "flex",
            justifyContent: "flex-end",
            columnGap: "15px",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              width: "120px",
              borderColor: "origin.main",
              color: "primary.main",
              "&:hover": {
                borderColor: "origin.main",
              },
            }}
            onClick={handleCancel}
          >
            {t("Cancel")}
          </Button>
          <ButtonAction name={t("Reset")} onClick={handleReset} type="reset" />

          <ButtonLoader
            name={t("submit")}
            onClick={() => handleSubmit(hanldeCreate)()}
            loading={loading}
            disableOnLoading
          >
            {t("submit")}
          </ButtonLoader>
        </Box>
      </BoxStyled>
    </Box>
  );
};

export default BusCreate;
